<template>
    <div style='width:794px;height:1123px;border:1px solid #000000;'>
        <router-view></router-view>
    </div>
</template>

<script>


export default {
    name:'IndexView',
    mounted(){
        console.log(this.$router,'router',this.$route.query);
    },
    methods:{
        GetView(){
        
        }
    }
}
</script>

<style>

</style>